import styled from '@emotion/styled';
import Menu from '../../Components/Menu';
import React, { useEffect, useRef, useState } from "react";
import emailjs, { init } from "@emailjs/browser";
import { Container, Grid } from "@mui/material";
import Footer from '../../Components/Footer/Footer';

import NtError from "../../Components/ErroBook/ntErro";
import { SubmitButton,RegWrapper,RegFormName,RegFormInput,Span} from './styles';
  
const Index = () => {
  const initialValues = {
    username: "",
    email: "",
    phonenumber: "",
    companyname: "",
    query: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  
  const [ useErrorType, setErrorType] = useState("a");
  const [ useError, setError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };
  useEffect(() => {
    setTimeout(() => {
      setError(false);
    }, 5000);
  }, [useError]);
  const validate = (values) => {
    const errors = {};
    const regex = /^[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/;
    const numbregex =/^\d{11}$/;
    
    if (!values.username) {
      errors.username = "Username is required!";                  
    }
    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }
    if (!values.phonenumber) {
      errors.phonenumber = "Phone Number is required!";
    } else if (!numbregex.test(values.phonenumber)) {
      errors.phonenumber = "This is not a valid phonenumber format!";
    }
    if (!values.companyname) {
      errors.companyname = "Add Your Company!";
    }
    if (!values.query) {
      errors.query = "Add Your Query!";
    }
    return errors;
  };
  init("yqj4LJV8S90nUqwdw");
  const form = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    if(formValues.email == "" || formValues.companyname == "" || formValues.phonenumber == "" || formValues.query == "" || formValues.username == ""){
      setErrorType("Not Submitted");
      setError(true);
    }
    
    else{
      setFormErrors(validate(formValues));
      setIsSubmit(true);
      emailjs.sendForm("service_3667tbq", "template_q8jlaje", form.current, "yqj4LJV8S90nUqwdw").then(
      (result) => { 
        setErrorType("Submitted");
      setError(true);
      formValues.companyname=""
      formValues.email=""
      formValues.phonenumber = ""
      formValues.query = ""
      formValues.username = ""
        console.log(result.text);
      },
      (error) => {
        console.log(error.text);
      }
    );
  }
  };
  return (
    <div>
      <Menu />
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          className=""
          style={{backgroundColor:'#B82E3C' ,padding:'7px 0' ,margin:'50px 0 30px 0'}}
        >
          <Grid xs={12} sm={12} md={12} className="text-center">
            <h1 className="fontweight ">
              <Span>Contact us</Span>
            </h1>
          </Grid>
        </Grid>    
        <Container>
          <Grid container spacing={8}>
            <Grid item xs={12} md={12}>
              <form onSubmit={handleSubmit}  ref={form}>
                <RegWrapper>
                  <RegFormName>
                    <label htmlFor="username">Name:</label>
                  </RegFormName>
                  <RegFormInput
                    value={formValues.username}
                    onChange={handleChange}
                    type="text"
                    name="username"
                    id="username"
                    placeholder="Enter name"
                  />
                </RegWrapper>
                {/* <div className="pt-2" style={{ color: "red" }}>
                  {formErrors.username}
                </div> */}
                
                <RegWrapper >
                  <RegFormName >
                    <label htmlFor="companyname">Company Name:</label>
                  </RegFormName>
                  <RegFormInput
                    value={formValues.companyname}
                    onChange={handleChange}
                    type="text"
                    name="companyname"
                    id="companyname"
                    placeholder="e.g. Tesla"
                  />
                </RegWrapper>
                {/* <div className="pt-2" style={{ color: "red" }}>
                  {formErrors.company}
                </div> */}

                <RegWrapper >
                  <RegFormName >
                    <label htmlFor="email">Email:</label>
                  </RegFormName>
                  <RegFormInput
                    value={formValues.email}
                    onChange={handleChange}
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Enter email"
                  />
                </RegWrapper>
                {/* <div className="pt-2" style={{ color: "red" }}>
                  {formErrors.email}
                </div> */}

                <RegWrapper >
                  <RegFormName >
                    <label htmlFor="phone">Phone Number:</label>
                  </RegFormName>
                  <RegFormInput
                    value={formValues.phonenumber}
                    type="number"
                    name="phonenumber"
                    id="phonenumber"
                    placeholder="Phone Number"
                    onChange={handleChange}
                  />
                </RegWrapper>
                <div className="pt-2" style={{ color: "red" }}>
                  {/* {formErrors.phonenumber} */}
                </div>
                <RegWrapper>
                <RegFormName>
            <label htmlFor="query">Query:</label>
                </RegFormName>
                  <RegFormInput
                    value={formValues.query}
                    onChange={handleChange}
                    type="text"
                    name="query"
                    id="query"
                    placeholder="Enter message"
                  />
          </RegWrapper>
          <div className="pt-2" style={{ color: "red" }}>
                  {/* {formErrors.query} */}
                </div>
                <br />
                  <SubmitButton
                    type="submit"
                  >
                    Submit
                  </SubmitButton>
              </form>
              {Object.keys(formErrors).length === 0 && isSubmit ? (
            <div style={{fontSize:22}} className="pt-5"> Submitted Successfully</div>
          ) : (
            <pre></pre>
          )}
            </Grid>
          </Grid>
        {useError ? <NtError errorType={useErrorType} /> : <span />}
        </Container>
    <Footer/>
    </div>
  )
}

export default Index